Object.defineProperty(exports, "__esModule", { value: true });
exports.Iframe = void 0;
const self_1 = require("./self");
const iframe_reset_1 = require("./iframe-reset");
exports.Iframe = (props) => {
    return self_1.getSelf(props, iframe_reset_1.iframeReset, 'iframe', props.iframeProps);
};
//# sourceMappingURL=iframe.js.map